import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Carrier } from "../../../types/CarrierTypes";

// fetchCarrier
export const fetchCarrier = createAsyncThunk<Carrier[], void, { rejectValue: string }>("carrier/fetchCarrier", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<Carrier[]>>(apiEndpoints.carrier.getAll);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch carrier.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

